import { useEffect } from "react";
import { isTokenExpired } from "../utils/isTokenExpired";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

// Firebase credentials

const useSessionManagement = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const checkSession = () => {
      const userdata = JSON.parse(localStorage.getItem("UserData"));
      if (isTokenExpired(userdata?.tokens?.access?.expires)) {
        toast.error("Session expired. Please log in again.");
        localStorage.clear();
        navigate("/login");
      }
    };

    // Check every second (1000 milliseconds)
    const intervalId = setInterval(checkSession, 1000);

    // Cleanup the interval on component unmount
    return () => clearInterval(intervalId);
  }, [navigate]);

  // Optionally, you can implement a function to refresh the token here
};

export default useSessionManagement;
